// src/components/BoutonGoogle.js
// Bouton « Continuer avec Google » (connexion et inscription en un clic)
import React, { useEffect, useState } from "react";
import { getRedirectResult } from "firebase/auth";
import { auth } from "../services/firebase";
import { useAuth } from "../contexts/AuthContext";

const SILENCIEUX = ["auth/popup-closed-by-user", "auth/cancelled-popup-request", "auth/user-cancelled"];

export function messageErreurGoogle(e) {
  if (!e || SILENCIEUX.includes(e.code)) return "";
  switch (e.code) {
    case "auth/network-request-failed": return "Pas de connexion internet. Réessayez.";
    case "auth/operation-not-allowed": return "La connexion Google n'est pas encore activée.";
    case "auth/unauthorized-domain": return "Connexion Google non autorisée sur cette adresse.";
    case "auth/account-exists-with-different-credential":
      return "Un compte existe déjà avec cet email : connectez-vous avec votre mot de passe.";
    case "auth/user-disabled": return "Ce compte a été désactivé.";
    default: return "Connexion Google impossible. Réessayez.";
  }
}

export default function BoutonGoogle({ onUser, onError, label = "Continuer avec Google", disabled }) {
  const { connecterGoogle } = useAuth();
  const [enCours, setEnCours] = useState(false);

  // Retour d'une redirection Google (app installée) : afficher l'erreur éventuelle
  useEffect(() => {
    getRedirectResult(auth).catch((e) => {
      const msg = messageErreurGoogle(e);
      if (msg && onError) onError(msg);
    });
  }, [onError]);

  async function handleClick() {
    setEnCours(true);
    if (onError) onError("");
    try {
      const user = await connecterGoogle();
      if (user && onUser) await onUser(user);
    } catch (e) {
      const msg = messageErreurGoogle(e);
      if (msg && onError) onError(msg);
    }
    setEnCours(false);
  }

  return (
    <button type="button" onClick={handleClick} disabled={disabled || enCours} style={s.btn}>
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
      </svg>
      <span>{enCours ? "Connexion…" : label}</span>
    </button>
  );
}

export function Separateur({ texte = "ou" }) {
  return (
    <div style={s.sep}>
      <span style={s.sepLigne} />
      <span style={s.sepTexte}>{texte}</span>
      <span style={s.sepLigne} />
    </div>
  );
}

const s = {
  btn: {
    display: "flex", alignItems: "center", justifyContent: "center", gap: "10px",
    width: "100%", padding: "0.8rem", background: "#fff", color: "#1f1f1f",
    border: "1.5px solid #dadce0", borderRadius: "12px", fontSize: "0.95rem",
    fontWeight: "600", cursor: "pointer", fontFamily: "inherit",
  },
  sep: { display: "flex", alignItems: "center", gap: "10px", margin: "1rem 0" },
  sepLigne: { flex: 1, height: "1px", background: "#e6e6ee" },
  sepTexte: { fontSize: "0.78rem", color: "#999" },
};
